
import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TitleBarComponent } from '../../shared/title-bar/title-bar.component';
import { AppErrorMessagesComponent } from '../../error-messages/app-error-messages.component';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PasswordVisibilityDirective } from 'src/app/directives/password-visibility.directive';
import { LoginFormType } from '../login-form-type';
import { AuthService } from '../../services/auth.service';
import { forgotPasswordRoute, homeRoute, twoFactorAuthenticationRecoveryRoute, twoFactorAuthenticationRegistrationRoute } from 'src/app/core/routing/route-names';
import { ToastService } from '../../services/toast.service';
import { LoginModel } from '../../shared/login.model';

@Component({
    selector: 'app-local-login',
    templateUrl: './local-login.component.html',
    styleUrls: ['./local-login.component.scss'],
    imports: [RouterLink, TranslateModule, TitleBarComponent, AppErrorMessagesComponent, ReactiveFormsModule, PasswordVisibilityDirective]
})
export class LocalLoginComponent implements OnInit {
  public loading = false;
  public loginForm: FormGroup<LoginFormType>;
  public forgotPasswordRoute = forgotPasswordRoute;
  public register2FARoute = twoFactorAuthenticationRegistrationRoute;
  public recover2FARoute = twoFactorAuthenticationRecoveryRoute;

  constructor(
    private authService: AuthService,
    private router: Router,
    private toastService: ToastService,
    private fb: FormBuilder) { }

  ngOnInit() {
    this.initializeForm();
    if (this.authService.isUserLoggedIn()) {
      this.router.navigate([homeRoute]);
    }
  }

  public login(): void {
    this.loading = true;

    const loginModel = {userName: this.loginForm.value.userName, password: this.loginForm.value.password, twoFactorAuthenticationToken: this.loginForm.value.twoFactorAuthenticationToken} as LoginModel;
    this.authService.login(loginModel).subscribe({
      next: result => {
        this.loading = false;

        if (result) {
          if (this.authService.redirectUrl) {
            this.router.navigateByUrl(this.authService.redirectUrl);
          } else {
            this.router.navigate([homeRoute]);
          }
        }
      },
      error: error => {
        this.loading = false;
        this.toastService.showApiException(error, 'i18n.core.messages.login.title', 'i18n.core.messages.login.message');
      }
    });
  }

  private initializeForm(): void {
    this.loginForm = this.fb.group<LoginFormType>({
      userName: this.fb.control<string>(null, [Validators.required]),
      password: this.fb.control<string>(null, [Validators.required]),
      twoFactorAuthenticationToken: this.fb.control<string>(null, [Validators.required]),
    });
  }
}
